import Repository from '@/repositories/repository'

const InsightProSignalsRepository = {
  async getInsightProSignalsData(queryParams: any = {}) {
    const params = {
      ...queryParams
    }

    return await Repository('insightpro-signals', 'page', params)
  }
}

export default InsightProSignalsRepository
